import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingCropPrimaryData, setFootprintingCropPrimaryDataAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_CROP, FOOTPRINTING_CROP_CALCULATED_FOOTPRINT, FOOTPRINTING_CROP_PRIMARY_DATA } from "consts";

export const useMutateFootprintingCropCreateManyBlankPrimaryData = (farmId: string, cropIds: string[], year: number) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;
  const queryFn = isAdmin ? setFootprintingCropPrimaryDataAdmin : setFootprintingCropPrimaryData;

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_CROP_PRIMARY_DATA, farmId, ...cropIds],
      mutationFn: async (selectedCropIds: string[]) => {
        await Promise.all(
          selectedCropIds.map((cId) =>
            queryFn({
              cropId: cId,
              farmId,
              year,
            })
          )
        );
      },
      onSuccess: async () => {
        cropIds.forEach((cId) => {
          const QKs = [
            [FOOTPRINTING_CROP_PRIMARY_DATA, farmId, cId, year],
            [FOOTPRINTING_CROP_CALCULATED_FOOTPRINT, farmId, cId, year],
            [FOOTPRINTING_CROP, farmId, cId, year],
          ];
          Promise.all(QKs.map((QK) => queryClient.invalidateQueries({ queryKey: QK })));
          Promise.all(QKs.map((QK) => queryClient.refetchQueries({ queryKey: QK })));
        });
      },
    },
    queryClient
  );
};
